<template>
  <div class="h-dialogContainer">
    <form id="busSetForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="h-inputLit">{{$t('System.runOpr')}}</div>
          <ejs-dropdownlist id="opr" ref="opr" :dataSource="oprs" :index="0" :change="getOprConfig"></ejs-dropdownlist>
        </div>
      </div>
      <div class="h-borderBox h-blueBg">
        <div class="row h-row-inputBox" v-if="alarmData">
          <div class="col-sm-12 h-col-inputBox">
            <div class="row h-row-insertBox">
              <div class="col-sm-6 h-col-insertBox">
                <div class="h-inputLit">{{$t('System.oprType')}}</div>
                <ejs-dropdownlist ref="types" :dataSource="types" :index="0" :change="getOprConfig"></ejs-dropdownlist>
              </div>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox">
          <div class="col-sm-12 h-col-inputBox">
            <div class="row h-row-insertBox">
              <div class="col-sm-6 h-col-insertBox">
                <div class="h-inputLit">{{$t('System.missResol')}}</div>
                <ejs-dropdownlist ref="mis" :dataSource="miss" :index="0" :change="setChildProps"></ejs-dropdownlist>
              </div>
              <div class="col-sm-6 h-col-insertBox">
                <div class="h-inputLit">{{title}}</div>
                <ejs-dropdownlist ref="combobox" :dataSource="timeData" :index="0" name="TimeCapData" :placeholder="inputText" v-model="timeCapData" @change="setChildProps"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row h-row-inputBox" v-if="showBack">
          <div class="col-sm-12 h-col-inputBox">
            <div class="row h-row-insertBox">
              <div class="col-sm-6 h-col-insertBox">
                <div class="form-group">
                  <div class="h-inputLit">{{$t('System.backupName')}}</div>
                  <div class="e-float-input">
                    <input ref="backInput" class="e-input e-input-group" name="BackupName" :placeholder='$t("System.inputTip2")' v-model="backupName" @change="setChildProps" />
                  </div>
                </div>
              </div>
              <div class="col-sm-6 h-col-insertBox">
                <div class="h-inputLit">{{$t('System.backupType')}}</div>
                <ejs-dropdownlist ref="backType" :dataSource="backTypes" :index="0" @change="setFtpShow"></ejs-dropdownlist>
              </div>
            </div>
          </div>
        </div>
        <div v-show="showFtp">
          <div class="b-t" style="margin-bottom: 20px"></div>
          <div class="row h-row-inputBox">
            <div class="col-sm-12 h-col-inputBox">
              <div class="row h-row-insertBox">
                <div class="col-sm-6 h-col-insertBox">
                  <div class="form-group">
                    <div class="h-inputLit">{{$t('System.ftpAddress')}}</div>
                    <div class="e-float-input">
                      <input ref="ftpAddress" class="e-input e-input-group" name="FtpAddress" :placeholder='$t("System.ftpAddressTip")' v-model="ftpAddress" @change="setChildProps" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 h-col-insertBox">
                  <div class="h-inputLit">{{$t('System.ftpPort')}}</div>
                  <input ref="ftpPort" class="e-input e-input-group" name="FtpPort" :placeholder='$t("System.ftpPortTip")' v-model="ftpPort" @change="setChildProps" />
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="col-sm-12 h-col-inputBox">
              <div class="row h-row-insertBox">
                <div class="col-sm-6 h-col-insertBox">
                  <div class="form-group">
                    <div class="h-inputLit">{{$t('System.ftpUser')}}</div>
                    <div class="e-float-input">
                      <input ref="ftpUser" class="e-input e-input-group" name="FtpUser" :placeholder='$t("System.ftpUser")' v-model="ftpUser" @change="setChildProps" />
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 h-col-insertBox">
                  <div class="h-inputLit">{{$t('System.ftpPassword')}}</div>
                  <input ref="ftpPassword" class="e-input e-input-group" name="FtpPassword" :placeholder='$t("System.ftpPassword")' v-model="ftpPassword" @change="setChildProps" />
                </div>
              </div>
            </div>
          </div>
          <div class="row h-row-inputBox">
            <div class="col-sm-12 h-col-inputBox">
              <div class="row h-row-insertBox">
                <div class="col-sm-12" style="text-align: right; padding: 0">
                  <button type="button" class="e-control e-btn e-lib e-primary e-flat" :title='$t("System.ftpTest")' @click="testFtp">
                    {{ftpTest}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import mixin from '../../mixin/mixin';
import {EventBus} from "../../plugins/eventBus";

export default {
  name: "BusSetDialog",
  mixins: [mixin],
  props: {
    fmOrAm: Number
  },
  data() {
    return {
      oprs: [
        { text: `${this.$t("System.onlyBackup")}`, value: "BACKUP" },
        { text: `${this.$t("System.onlyDel")}`, value: "DELETE" },
        { text: `${this.$t("System.backupAndDel")}`, value: "BACKUPANDDELETE" }
      ],
      types: [
        { text: `${this.$t("System.acTime")}`, value: "byTime" },
        { text: `${this.$t("System.acArea")}`, value: "byCapacity" }
      ],
      miss: [
        { text: `${this.$t("System.continueRun")}`, value: "CONTINUE" },
        { text: `${this.$t("System.stopRun")}`, value: "STOP" }
      ],
      backTypes: [
        { text: `${this.$t("System.localSave")}`, value: "LOCAL" },
        { text: `${this.$t("System.remoteSave")}`, value: "REMOTE" },
        { text: `${this.$t("System.bothSave")}`, value: "BOTH" }
      ],
      timeData: [
        { text: `${this.$t("System.beforeDay7")}`, value: 7 },
        { text: `${this.$t("System.beforeDay15")}`, value: 15 },
        { text: `${this.$t("System.beforeDay30")}`, value: 30 }
      ],
      capData: [
        { text: `${this.$t("System.num1000")}`, value: 1000 },
        { text: `${this.$t("System.num3000")}`, value: 3000 },
        { text: `${this.$t("System.num5000")}`, value: 5000 },
        { text: `${this.$t("System.num10000")}`, value: 10000 }
      ],
      alarmData: false,
      showBack: true,
      title: `${this.$t("System.backupTime")}`,
      inputText: `${this.$t("System.inputTip3")}`,
      timeCapData: "",
      backupName: "",
      inputNames: ['BackupName','TimeCapData','FtpAddress','FtpPort'],
      rules: {
        TimeCapData:{ required: true },
        BackupName: { required: true, regex: 'specialEn', maxLength: 255},
        FtpAddress:{regex: 'ipv4'},
        FtpPort: {range: [1,65535]}
      },
      formObj: "",
      showFtp: false,
      ftpAddress: '',
      ftpPort: '',
      ftpUser: '',
      ftpPassword: '',
      ftpTest: this.$t("System.ftpTest")
    };
  },
  methods: {
    getOprConfig() {
      let oprIndex = 0;
      let typeIndex = 0;
      oprIndex = this.$refs.opr.ej2Instances.index;
      if (this.$refs.types) {
        typeIndex = this.$refs.types.ej2Instances.index;
      }
      if (oprIndex === 0) {
        this.showBack = true;
        if (typeIndex === 0) {
          this.title = `${this.$t("System.backupTime")}`;
          this.inputText = `${this.$t("System.inputTip3")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.timeData;
        } else {
          this.title = `${this.$t("System.backupArea")}`;
          this.inputText = `${this.$t("System.inputTip4")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.capData;
        }
      } else if (oprIndex === 1) {
        this.showBack = false;
        if (typeIndex === 0) {
          this.title = `${this.$t("System.delTime")}`;
          this.inputText = `${this.$t("System.inputTip5")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.timeData;
        } else {
          this.title = `${this.$t("System.delArea")}`;
          this.inputText = `${this.$t("System.inputTip6")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.capData;
        }
      } else {
        this.showBack = true;
        if (typeIndex === 0) {
          this.title = `${this.$t("System.oprTime")}`;
          this.inputText = `${this.$t("System.inputTip3")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.timeData;
        } else {
          this.title = `${this.$t("System.oprArea")}`;
          this.inputText = `${this.$t("System.inputTip4")}`;
          this.$refs.combobox.ej2Instances.dataSource = this.capData;
        }
      }
      this.$refs.combobox.ej2Instances.index = 0;
      this.setChildProps();
    },
    setChildProps() {
      let timeCapLong = "";
      if (this.timeCapData) {
        const regular = /[0-9][0-9]*/g;
        timeCapLong = this.timeCapData.match(regular)[0];
      }
      let oprIndex = 0;
      let typeIndex = 0;
      let misIndex = 0;
      let backTypeIndex = 0;
      oprIndex = this.$refs.opr.ej2Instances.index;
      let childProps = {
        operType: this.oprs[oprIndex].value,
        operAttr: {}
      };
      if (this.showFtp) {
        childProps.operAttr.FTPUrl = this.ftpAddress;
        childProps.operAttr.FTPpassword = this.ftpPassword;
        childProps.operAttr.FTPport = this.ftpPort;
        childProps.operAttr.FTPusername = this.ftpUser;
      } else {
        childProps.operAttr.FTPUrl = '';
        childProps.operAttr.FTPpassword = '';
        childProps.operAttr.FTPport = '';
        childProps.operAttr.FTPusername = '';
      }
      if (this.alarmData) {
        if (this.$refs.types) {
          typeIndex = this.$refs.types.ej2Instances.index;
        }
        childProps.operAttr.operStyle = this.types[typeIndex].value;
        //区分备份时间 or 备份容量
        if (typeIndex === 0) {
          childProps.operAttr.backupTime = timeCapLong;
          childProps.operAttr.deleteTime = timeCapLong;
          childProps.operAttr.backupCapacity = "";
        } else {
          childProps.operAttr.backupTime = "";
          childProps.operAttr.deleteTime = "";
          childProps.operAttr.backupCapacity = timeCapLong;
        }
      } else {
        childProps.operAttr.backupTime = timeCapLong;
        childProps.operAttr.deleteTime = timeCapLong;
      }
      if (this.$refs.mis) {
        misIndex = this.$refs.mis.ej2Instances.index;
        childProps.operAttr.errorDeal = this.miss[misIndex].value;
      }
      if (this.$refs.backType) {
        backTypeIndex = this.$refs.backType.ej2Instances.index;
        childProps.operAttr.backupType = this.backTypes[backTypeIndex].value;
      }
      if (this.$refs.backInput) {
        childProps.operAttr.backupName = this.backupName;
      }
      this.$emit("childProps", childProps);
    },
    setBasicTitle() {
      if (this.fmOrAm === 0) {
        this.alarmData = false;
      } else {
        this.alarmData = true;
      }
      this.setChildProps();
    },
    validate() {
      let formStatus = this.formObj.validate();
      return formStatus;
    },
    bindValidate() {
      this.formObj = this.validateForm('busSetForm', this.inputNames, this.rules);
    },
    testFtp(){
      if(this.ftpAddress == ''){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.ftpAddressNotNull')});
        return null;
      }
      if(this.ftpPort == ''){
        EventBus.$emit('toast', {type: 'warning', content: this.$t('System.ftpPortNotNull')});
        return null;
      }
      const url = '/lte/ems/sysmanager/task/ftpLoginVerify';
      const map = {
        FTPUrl: this.ftpAddress,
        FTPpassword: this.ftpPassword,
        FTPport: this.ftpPort,
        FTPusename: this.ftpUser
      };
      const params = {
        operAttr: map
      };
      
      this.$loading.showLoadding(this.$t('System.loading'));
      this.axios.post(url, params).then(response => {
        this.$loading.hideLoadding();
        if (response.data === 0) {
          EventBus.$emit('toast', {type: 'success', content: this.$t('Common.tips.success')});
        } else {
          EventBus.$emit('toast', {type: 'error', content: this.$t('Common.tips.failure')});
        }
      });
    },
    setFtpShow(){
      const index = this.$refs.backType.ej2Instances.index;
      if (index === 0) {
        this.showFtp = false;
        this.ftpPort = '';
        this.ftpAddress = '';
      } else {
        const ftpRules = ['FtpAddress','FtpPort'];
        ftpRules.forEach((item) =>{
          let id = item+"-info";
          if(document.getElementById(id)){
            document.getElementById(id).style.display = "none" ;
          }
          let temp = document.getElementsByName(item);
          temp[0].classList.remove("e-error");
        });
        this.showFtp = true;
      }
      this.setChildProps();
    }
  },
  mounted() {
    this.setBasicTitle();
  },
  watch: {
    fmOrAm() {
      this.setBasicTitle();
    }
  }
};
</script>
